"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Label = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let Label = exports.Label = /*#__PURE__*/function (Label) {
  Label["Clear"] = "Clear search field";
  Label["Search"] = "Search";
  return Label;
}({});
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [SearchBox](https://docs.vanillaframework.io/patterns/search-box/).
 *
 * Search boxes enable search functionality on a page and are typically used in a navigation bar. SearchBox elements should be wrapped within a form element that handles its own submit action.
 */
const SearchBox = /*#__PURE__*/_react.default.forwardRef((_ref, forwardedRef) => {
  let {
    name = "search",
    id = "search",
    autocomplete = "on",
    className,
    disabled,
    externallyControlled,
    onChange,
    onSearch,
    onClear,
    placeholder = "Search",
    shouldBlurOnSearch = true,
    shouldRefocusAfterReset,
    value,
    ...props
  } = _ref;
  const internalRef = (0, _react.useRef)(null);
  const resetInput = () => {
    onChange === null || onChange === void 0 || onChange("");
    onClear === null || onClear === void 0 || onClear();
    if (internalRef.current) {
      internalRef.current.value = "";
      if (shouldRefocusAfterReset) internalRef.current.focus();
    }
  };
  const triggerSearch = () => {
    onSearch === null || onSearch === void 0 || onSearch(externallyControlled ? value : internalRef.current.value);
  };
  const onKeyDown = e => {
    if (e.key === "Enter" && internalRef.current.checkValidity()) {
      if (shouldBlurOnSearch) {
        internalRef.current.blur();
      }
      triggerSearch();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("p-search-box", className)
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "u-off-screen",
    htmlFor: id
  }, placeholder || "Search"), /*#__PURE__*/_react.default.createElement("input", _extends({
    autoComplete: autocomplete,
    className: "p-search-box__input",
    disabled: disabled,
    id: id,
    name: name,
    onChange: evt => onChange === null || onChange === void 0 ? void 0 : onChange(evt.target.value),
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    ref: input => {
      internalRef.current = input;
      // Handle both function and object refs.
      if (typeof forwardedRef === "function") {
        forwardedRef(input);
      } else if (forwardedRef) {
        forwardedRef.current = input;
      }
    },
    type: "search",
    defaultValue: externallyControlled ? undefined : value,
    value: externallyControlled ? value : undefined
  }, props)), value && /*#__PURE__*/_react.default.createElement("button", {
    className: "p-search-box__reset",
    disabled: disabled,
    onClick: resetInput,
    type: "reset"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "close"
  }, Label.Clear)), /*#__PURE__*/_react.default.createElement("button", {
    className: "p-search-box__button",
    disabled: disabled,
    onClick: triggerSearch
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "search"
  }, Label.Search)));
});
SearchBox.displayName = "SearchBox";
var _default = exports.default = SearchBox;